import {errorHitFifteenDays} from "./errorhit.js";

document.addEventListener('DOMContentLoaded', () => {
  errorHitFifteenDays();
});
